import CalculatorIcon from '../../../../../icons/calculator.svg';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg';
import DocumentIcon from '../../../../../icons/document.svg';

export default function PurchasingProcessData() {
  return {
    subtitle: "Working with Medicare BackOffice’s experienced licensed insurance agents gives you the information you need, at no cost to you.",
    image: "/product-landing/perm/circle1.png",
    steps: [
      {
        title: "Needs Analysis",
        icon: CalculatorIcon,
        paragraphs: [
          "Our agents will discuss all of your options, whether you are enrolling in Medicare for the first time or if you just want to review your options."
        ]
      },
      {
        title: "Get a Quote",
        icon: DollarTagIcon,
        paragraphs: [
          "We aren’t limited to just one carrier. We are contracted and certified with top carriers nationwide, so we can help you find a suitable plan for your needs.",
        ]
      },
      {
        title: "Select and Apply",
        icon: HandSelectClickIcon,
        paragraphs: [
          "You’ll be able to select the plan you want: our agents are here to help educate you on all of your choices. After you select your plan, they’ll walk you through the application process.",
        ]
      },
      {
        title: "Policy Delivery",
        icon: DocumentIcon,
        paragraphs: [
          "Once your application has been approved you will be notified about your policy’s delivery. From there you will receive a physical copy of your policy documents.",
        ]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Navi/PurchasingProcessData.js